import { LearnGroup, Strategy } from '@/types'
import { PersonaUtils } from '../utils'
import { resolveStrategyAction } from '@/utils'
import { navigation } from '@/app'
import { PersonaCTAModal } from '../components'
import { maybeOpenRegistrationWall } from '@/features/Auth/session/registrationWall'

function openMyJourney() {
  const canProceed = maybeOpenRegistrationWall()
  if (!canProceed) {
    return
  }

  const hasMissingAnswers = PersonaUtils.hasMissingAnswers()
  if (hasMissingAnswers) {
    PersonaCTAModal.toggle()
    return
  }

  navigation.navigate('Learn.MyJourney')
}

export class OpenGroup {
  private static strategies = [
    {
      matches: item => item.id === 'personalized_content',
      execute: openMyJourney,
      name: 'my_journey'
    },
    {
      matches: () => true,
      execute: item => navigation.navigate('Learn.Content', { id: item.id }),
      name: 'default'
    }
  ] satisfies Strategy<LearnGroup>[]

  static resolve(item: LearnGroup) {
    return resolveStrategyAction(item, OpenGroup.strategies, 'OpenGroup')
  }

  static execute(item: LearnGroup) {
    const strategy = OpenGroup.resolve(item)
    return strategy.execute(item)
  }
}
